import GeneralConditions from './components/footer/GeneralConditions';
import PrivacyPolicy from './components/footer/PrivacyPolicy';
import TermsAndConditions from './components/footer/TermsAndConditions';
import formasDePago from './components/formas-de-pago/formas-de-pago';
import ConsultaDetalle from './components/layout/consulta-detalle/formulario-consulta-detalle';
import MapAgencies from './components/map-agencies/map-agencies';
import Reclamos from './components/reclamos/reclamos';
import { ROUTE_KEYS } from './constants';
import UnifiedLayout from './components/layout/UnifiedLayout';
import BannerDetail from './views/banner-detalle/BannerDetail';
import CustomSection from './views/custom-section/custom-section';
import HomeView from './views/HomeView';
import PackageDetail from './views/paquete-detalle/PackageDetail';
import InternalPackageDetail from './views/paquete-detalle/InternalPackageDetail';
import PackageListPage from './views/paquetes/pages/PackageListPage';
import FlightListPage from './views/vuelos/pages/FlightListPage';
import HotelListPage from './views/hoteles/pages/HotelListPage';
import InternalHotelsRouteGuard from './views/hoteles/components/InternalHotelsRouteGuard';
import { HotelDetailPage } from 'frontend/features/hotels';
import BookingPageWrapper from './components/flights/Booking/BookingPageWrapper';
import formularioArrepentimiento from './components/layout/layout-arrepentimiento/formulario-arrepentimiento';
import withSearcherValidation from './hoc/withSearcherValidation';
import LandingView from './views/LandingView';
import NotFoundView from './views/NotFoundView';
import ItineraryViewer from 'frontend/features/itinerary-viewer/ItineraryViewer';

const {
  HOME,
  BUSCAR_X_PAQUETES,
  BUSCAR_X_VUELOS,
  BUSCAR_X_HOTELES,
  BUSCAR_X_HOTELES_DETALLE,
  CONSULTA,
  CONSULTA_DETALLE,
  PAQUETE,
  BUSCAR_X_VUELOS_RESERVA,
  PAQUETES,
  AGENCIES,
  CLAIMS,
  PAY_METHODS,
  PRIVACY_POLICY,
  GENERAL_CONDITIONS,
  TERMS_AND_CONDITIONS,
  ARREPENTIMIENTO,
  CUSTOM_SECTION,
} = ROUTE_KEYS;

export const withLayout = (Component, options = {}) => {
  const {
    showSearchBar = false,
    hideFAB = false,
    showBillboard = true,
    hideHeader = false,
    hideMobileNavMenu = false,
  } = options;

  return (props) => (
    <UnifiedLayout
      showSearchBar={showSearchBar}
      hideFAB={hideFAB}
      showBillboard={showBillboard}
      hideHeader={hideHeader}
      hideMobileNavMenu={hideMobileNavMenu}
    >
      <Component {...props} />
    </UnifiedLayout>
  );
};

const withInternalHotelsRouteGuard = (Component) => {
  const WithInternalHotelsRouteGuardComponent = (props) => (
    <InternalHotelsRouteGuard>
      <Component {...props} />
    </InternalHotelsRouteGuard>
  );

  WithInternalHotelsRouteGuardComponent.displayName = `withInternalHotelsRouteGuard(${Component.displayName || Component.name || 'Component'})`;

  return WithInternalHotelsRouteGuardComponent;
};

const routes = [
  {
    path: HOME,
    exact: true,
    component: withLayout(HomeView),
  },
  {
    path: BUSCAR_X_PAQUETES,
    exact: true,
    component: withLayout(withSearcherValidation(PackageListPage), {
      showSearchBar: true,
    }),
  },
  {
    path: BUSCAR_X_VUELOS,
    exact: true,
    component: withLayout(withSearcherValidation(FlightListPage), {
      showSearchBar: true,
    }),
  },
  {
    path: BUSCAR_X_HOTELES,
    exact: true,
    component: withLayout(withInternalHotelsRouteGuard(HotelListPage), {
      showSearchBar: true,
    }),
  },
  {
    path: `${BUSCAR_X_HOTELES_DETALLE}/:hotelId`,
    exact: true,
    component: withLayout(withInternalHotelsRouteGuard(HotelDetailPage), {
      hideFAB: true,
    }),
  },
  {
    path: BUSCAR_X_VUELOS_RESERVA,
    exact: true,
    component: withLayout(withSearcherValidation(BookingPageWrapper)),
  },
  {
    path: ARREPENTIMIENTO,
    component: withLayout(formularioArrepentimiento),
  },
  {
    path: PRIVACY_POLICY,
    component: withLayout(PrivacyPolicy),
  },
  {
    path: GENERAL_CONDITIONS,
    component: withLayout(GeneralConditions),
  },
  {
    path: TERMS_AND_CONDITIONS,
    component: withLayout(TermsAndConditions),
  },
  {
    path: CLAIMS,
    component: withLayout(Reclamos),
  },
  {
    path: `${CUSTOM_SECTION}/:id/:slug`,
    component: withLayout(CustomSection),
  },
  {
    path: `${CUSTOM_SECTION}/:id`,
    component: withLayout(CustomSection),
  },
  {
    path: '/landing/:id/:slug',
    exact: true,
    component: withLayout(LandingView, {
      showBillboard: true,
      hideFAB: true,
      hideMobileNavMenu: true,
    }),
  },
  {
    path: '/landing/:id',
    exact: true,
    component: withLayout(LandingView, {
      showBillboard: true,
      hideFAB: true,
      hideMobileNavMenu: true,
    }),
  },
  {
    path: AGENCIES,
    component: withLayout(MapAgencies),
  },
  {
    path: PAY_METHODS,
    component: withLayout(formasDePago),
  },
  {
    path: `${CONSULTA}/:id/:slug`,
    component: withLayout(BannerDetail, { hideFAB: true }),
  },
  {
    path: `${CONSULTA}/:id`,
    component: withLayout(BannerDetail, { hideFAB: true }),
  },
  {
    path: `${CONSULTA_DETALLE}/:id`,
    component: withLayout(ConsultaDetalle),
  },
  {
    path: `${PAQUETE}/:id`,
    component: withLayout(PackageDetail, { hideFAB: true }),
  },
  {
    path: PAQUETES,
    component: withLayout(InternalPackageDetail, { hideFAB: true }),
  },
  {
    path: '/itinerario/:shareToken',
    exact: true,
    component: ItineraryViewer,
  },
  {
    path: '*',
    component: withLayout(NotFoundView),
  },
];

export default routes;
